import React from "react";
import Banner from "../Banner";
import Slider from "../Slider";
import Problems from "../Problems";
import FindCreditCard from "../FindCreditCard";
import HowItWorks from "../HowItWorks";
import Benefits from "../Benefits";
import LinkPanels from "./LinkPanels.js";
// import Alumni from "../Alumni";
import "../../common/styles/global.scss";
import AppStoreAd from "./AppStoreAd.js";
import RecentArticles from "./RecentArticles.js";

const Home = (props) => {
  return (
    <>
      <Banner {...props} />
      <LinkPanels {...props} />


      <div style={{marginTop: 30, marginBottom: 30}}>
            <iframe
                src="https://embeds.beehiiv.com/1844ac4f-e640-4e88-964d-5c2a1065308f" 
                dataTestId="beehiiv-embed" 
                width="100%" height="320" frameBorder="0" scrolling="no" 
                style={{
                      borderRadius: "4px", 
                      border: "2px solid #e5e7eb",
                      margin: 0, 
                      backgroundColor: "transparent"
                }}
            >
            </iframe>
      </div>

      <div style={{borderBottom: "2px solid #e6e7eb", display: "flex", justifyContent: "center"}}>
        <RecentArticles/>
      </div>

      <AppStoreAd {...props} />
      {/* <Problems {...props} /> */}
      <FindCreditCard {...props} />
      <HowItWorks {...props} />
      <Benefits {...props} />
      {/*<Alumni {...props} />*/}
    </>
  );
};

export default Home;
